﻿import { getAddress } from '../../utils/getAddress.js';

export const initWoningPage = () => {
    const passAdressBtn =  document.getElementById('pass-address-button');
    const zipCodeInput = document.getElementById('Postcode');
    const houseNumberInput = document.getElementById('Huisnummer');
    const notification = document.getElementById('PostcodeNietGevonden');
    const submitForm = document.getElementById("AdresOpslaan");
    
    if(!passAdressBtn) {
        return;
    }

    const setPostcodeNotification = visible => {
        notification?.toggleAttribute('hidden', !visible)
    }

    const openAddresDialog = () => {
        window.dialog.open({
            url: passAdressBtn.dataset.url,
            title: passAdressBtn.dataset.title,
            size: "small"
        })
    }
    
    const debounce = (callback, delay) => {
        let timeoutId = null;

        return () => { 
            clearTimeout(timeoutId); 
            timeoutId = setTimeout(callback, delay); 
        };
    }

    const getAdddress = async () => {
        const zipCodeValue = zipCodeInput.value;
        const houseNumberValue = houseNumberInput.value;
        
        if (!zipCodeValue || !houseNumberValue) {
            console.log('Exit here')
            return;
        }
        
        const found = await getAddress({
            zipcode: zipCodeValue,
            houseNumber: houseNumberValue,
            streetFieldRole: 'straatnaam',
            cityFieldRole: 'plaatsnaam',
        });

        setPostcodeNotification(!found)
        
    }
    
    const handleFormSubmit = () => {
        submitForm.querySelector('button[type="submit"]').loading = true;
    }
    
    const getAddressDebounced = debounce(() => { getAdddress(); }, 300);

    passAdressBtn?.addEventListener('click', openAddresDialog)
    zipCodeInput?.addEventListener('change', getAddressDebounced)
    houseNumberInput?.addEventListener('change', getAddressDebounced)
    submitForm?.addEventListener('submit', handleFormSubmit);
}
